var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-channel" },
    [
      _c(
        "el-form",
        {
          ref: "formDataRef",
          attrs: {
            model: _vm.queryForm,
            "label-position": "top",
            disabled: _vm.operateType === 1,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("operationCenter.channel"),
                        prop: "channelValue",
                        rules: {
                          required: true,
                          message: _vm.$t("basicData.CannotBeEmpty"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                            disabled: _vm.operateType === 2,
                          },
                          model: {
                            value: _vm.queryForm.channelValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "channelValue", $$v)
                            },
                            expression: "queryForm.channelValue",
                          },
                        },
                        _vm._l(_vm.channelOption, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.dictName,
                              value: item.dictValue,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.stateZT"),
                        prop: "status",
                        rules: {
                          required: true,
                          message: _vm.$t("basicData.CannotBeEmpty"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.queryForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "status", $$v)
                            },
                            expression: "queryForm.status",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "1",
                            attrs: {
                              label: _vm.$t("GlobalSetObj.enable"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            key: "2",
                            attrs: {
                              label: _vm.$t("GlobalSetObj.disable"),
                              value: 0,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("customerManagements.ExpressSmallParcel"))
                  ),
                ]),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    { staticStyle: { width: "200px" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "smallCalculationMethod",
                            rules: {
                              required:
                                !(
                                  (_vm.queryForm.largeCalculationMethod === 0 ||
                                    _vm.queryForm.largeCalculationMethod ===
                                      1) &&
                                  (_vm.queryForm.largeCalculateBase ||
                                    _vm.queryForm.largeCalculateBase === 0)
                                ) ||
                                _vm.queryForm.smallCalculateBase ||
                                _vm.queryForm.smallCalculateBase === 0,
                              message: _vm.$t("basicData.CannotBeEmpty"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.smallCalculationMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm,
                                    "smallCalculationMethod",
                                    $$v
                                  )
                                },
                                expression: "queryForm.smallCalculationMethod",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: { label: "*", value: 0 },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: { label: "/", value: 1 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "smallCalculateBase",
                            rules: [
                              {
                                required:
                                  !(
                                    (_vm.queryForm.largeCalculationMethod ===
                                      0 ||
                                      _vm.queryForm.largeCalculationMethod ===
                                        1) &&
                                    (_vm.queryForm.largeCalculateBase ||
                                      _vm.queryForm.largeCalculateBase === 0)
                                  ) ||
                                  _vm.queryForm.smallCalculationMethod === 0 ||
                                  _vm.queryForm.smallCalculationMethod === 1,
                                message: _vm.$t("basicData.CannotBeEmpty"),
                                trigger: ["blur", "change"],
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
                                message: _vm.$t(
                                  "compensationManagement.inputdayuzuoduo2"
                                ),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseInput"
                              ),
                            },
                            model: {
                              value: _vm.queryForm.smallCalculateBase,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm,
                                  "smallCalculateBase",
                                  $$v
                                )
                              },
                              expression: "queryForm.smallCalculateBase",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("customerManagements.ExpressLargeParcel"))
                  ),
                ]),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    { staticStyle: { width: "200px" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "largeCalculationMethod",
                            rules: {
                              required:
                                !(
                                  (_vm.queryForm.smallCalculationMethod === 0 ||
                                    _vm.queryForm.smallCalculationMethod ===
                                      1) &&
                                  (_vm.queryForm.smallCalculateBase ||
                                    _vm.queryForm.smallCalculateBase === 0)
                                ) ||
                                _vm.queryForm.largeCalculateBase ||
                                _vm.queryForm.largeCalculateBase === 0,
                              message: _vm.$t("basicData.CannotBeEmpty"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.largeCalculationMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm,
                                    "largeCalculationMethod",
                                    $$v
                                  )
                                },
                                expression: "queryForm.largeCalculationMethod",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: { label: "*", value: 0 },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: { label: "/", value: 1 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "largeCalculateBase",
                            rules: [
                              {
                                required:
                                  !(
                                    (_vm.queryForm.smallCalculationMethod ===
                                      0 ||
                                      _vm.queryForm.smallCalculationMethod ===
                                        1) &&
                                    (_vm.queryForm.smallCalculateBase ||
                                      _vm.queryForm.smallCalculateBase === 0)
                                  ) ||
                                  _vm.queryForm.largeCalculationMethod === 0 ||
                                  _vm.queryForm.largeCalculationMethod === 1,
                                message: _vm.$t("basicData.CannotBeEmpty"),
                                trigger: ["blur", "change"],
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
                                message: _vm.$t(
                                  "compensationManagement.inputdayuzuoduo2"
                                ),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseInput"
                              ),
                            },
                            model: {
                              value: _vm.queryForm.largeCalculateBase,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm,
                                  "largeCalculateBase",
                                  $$v
                                )
                              },
                              expression: "queryForm.largeCalculateBase",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "el-col",
                { staticStyle: { "margin-top": "20px" }, attrs: { span: 24 } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "margin-bottom": "20px",
                        "align-items": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "50px",
                            "text-align": "center",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning-outline",
                            staticStyle: { "font-size": "24px" },
                          }),
                        ]
                      ),
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("ChannelManage.WhenTheStatusIsEnabled")
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "margin-bottom": "20px",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", { staticStyle: { width: "50px" } }),
                    _c("div", { staticStyle: { flex: "1" } }, [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("ChannelManage.ConfigureCalculateTheBase")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "ChannelManage.ConfigurationCalculatedUsingBase"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("ChannelManage.TheUnitsAllCentimeters")
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }